import InviteInduction from './InviteInduction'
export default InviteInduction